import { EnumProductGuardService } from '@shared/services/enum-product-guard.service';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe, CurrencyPipe } from '@angular/common';
import { ShopRoutingModule } from './shop-routing.module';
import { SharedModule } from '@shared/shared.module';
// import { SlickCarouselModule } from 'ngx-slick-carousel';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxPayPalModule } from 'ngx-paypal';
import { NgxImgZoomModule } from 'ngx-img-zoom';

// Products Components
import { ProductComponent } from './product/product.component';
import { CollectionNoSidebarComponent } from './product/collection/collection-no-sidebar/collection-no-sidebar.component';
import { ColorComponent } from './product/collection/filter/color/color.component';
import { BrandComponent } from './product/collection/filter/brand/brand.component';
import { PriceComponent } from './product/collection/filter/price/price.component';

import { CategoriesComponent } from './product/widgets/categories/categories.component';
import { ModalCartComponent } from './product/widgets/modal-cart/modal-cart.component';
import { NewProductComponent } from './product/widgets/new-product/new-product.component';
import { SuccessComponent } from './product/success/success.component';
import { ExitPopupComponent } from './product/widgets/exit-popup/exit-popup.component';
import { NgbAccordionModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RecaptchaModule, RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { SlotDetailsMobileComponent } from './product/product-details/slot-details-mobile/slot-details-mobile.component';
import { CaptchaModalComponent } from './product/product-details/captcha-modal/captcha-modal.component';
import { MyOrdersComponent } from './product/my-orders/my-orders.component';
import { MyOrdersDetailsComponent } from './product/my-orders/my-orders-details/my-orders-details.component';
import { MyOrdersProductsComponent } from './product/my-orders/my-orders-details/my-orders-products/my-orders-products.component';
import { MyOrdersFilterComponent } from './product/my-orders/my-orders-filter/my-orders-filter.component';
import { MyOrdersReceiptComponent } from './product/my-orders/my-orders-details/my-orders-receipt/my-orders-receipt.component';
// import { VSelectModule } from '@shared/features/v-select/v-select.module';
import { SelectSeatsComponent } from './product/product-details/select-seats/select-seats.component';
import { CartRegistryComponent } from './product/cart-registry/cart-registry.component';
import { ProductViewComponent } from './product/product-details/product-view/product-view.component';
import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { ChangeRegistryModalComponent } from './product/my-orders/my-orders-details/my-orders-products/change-registry-modal/change-registry-modal.component';
import { ResalePolicyModalComponent } from './product/my-orders/my-orders-details/my-orders-products/resale-policy-modal/resale-policy-modal.component';
// import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { RegistryChangeComponent } from './product/order-actions/registry-change/registry-change.component';
import { ResaleRequestComponent } from './product/order-actions/resale-request/resale-request.component';
import { environment } from 'src/environments/environment';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
// import { PopoverModule, ModalModule, BsModalRef } from 'ngx-bootstrap/modal';
import {  ModalModule, BsModalRef } from 'ngx-bootstrap/modal';
import { UserProfileComponent } from './user/user-profile/user-profile.component';
import { RegisterPageComponent } from './user/register-page/register-page.component';
import { ResaleTicketFormComponent } from './product/cart-registry/resale-ticket-form/resale-ticket-form.component';
import { TicketFormComponent } from './product/cart-registry/ticket-form/ticket-form.component';
import { ChangeUserRequestComponent } from './product/order-actions/change-user-request/change-user-request.component';
import { ChangeSupportRequestComponent } from './product/order-actions/change-support-request/change-support-request.component';
import { RefinementRequestComponent } from './product/order-actions/refinement-request/refinement-request.component';
import { ConversionRequestComponent } from './product/order-actions/conversion-request/conversion-request/conversion-request.component';
import { MyOrdersExtraProductsComponent } from './product/my-orders/my-orders-details/my-orders-extra-products/my-orders-extra-products.component';
import { ExtraProductComponent } from './product/cart-registry/extra-product/extra-product.component';
import { ShippingMethodComponent } from './product/cart-registry/shipping-method/shipping-method.component';
import { ChangeShippingAddressModalComponent } from './product/my-orders/my-orders-details/change-shipping-address-modal/change-shipping-address-modal.component';
import { PaymentMethodComponent } from './product/cart-registry/payment-method/payment-method.component';
import { PaymentMethodModalComponent } from './product/cart-registry/payment-methos-modal/payment-methos-modal.component';
import { PreemptionSeatsComponent } from './product/product-details/preemption/preemption-seats.component';
import { PrTagEventsComponent } from './pr/pr-tag-events/pr-tag-events.component';
import { AddToGoogleComponent } from './product/my-orders/my-orders-details/add-to-google/add-to-google.component';
import { VSelectComponent } from '@shared/features/v-select/v-select/v-select.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ProductCalendarViewComponent } from './product-calendar/product-calendar-view/product-calendar-view.component';
import { CalendarViewComponent } from './product-calendar/calendar-view/calendar-view.component';
import { SwiperService } from '@core/services/swiper.service';
import { OptionalPaymentMethodComponent } from './product/cart-registry/optional-payment-method/optional-payment-method.component';
import { NewExtraProductComponent } from './product/cart-registry/new-extra-product/new-extra-product.component';
import { SubscriptionTicketComponent } from './product/order-actions/subscription-ticket/subscription-ticket.component';
import { SubscriptionTicketItemComponent } from './product/order-actions/subscription-ticket/subscription-ticket-item/subscription-ticket-item.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { HttpClientJsonpModule } from '@angular/common/http';
import { ManagementModule } from './nameless-festival/management/management.module';


@NgModule({ exports: [ExitPopupComponent, VSelectComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [CommonModule,
        ShopRoutingModule,
        SharedModule,
        // RangeSliderModule,
        // InfiniteScrollModule,
        NgxPayPalModule,
        // NgxImgZoomModule,
        NgbAccordionModule,
        RecaptchaModule,
        NgbModule,
        VSelectComponent,
        FullCalendarModule,
        // VirtualScrollerModule,
        RecaptchaV3Module,
         NgxChartsModule,
        // HttpClientModule,
        HttpClientJsonpModule,
        // TooltipModule.forRoot(),
        // PopoverModule.forRoot(),
        ModalModule.forRoot(),
        ManagementModule,
        SelectSeatsComponent,
        ProductComponent,
        CollectionNoSidebarComponent,
        ColorComponent,
        BrandComponent,
        // PriceComponent,
        CategoriesComponent,
        ProductCalendarViewComponent,
        CalendarViewComponent,
        ModalCartComponent,
        NewProductComponent,
        SuccessComponent,
        ExitPopupComponent,
        SlotDetailsMobileComponent,
        CaptchaModalComponent,
        MyOrdersComponent,
        // VSelectComponent,
        MyOrdersDetailsComponent,
        MyOrdersProductsComponent,
        MyOrdersFilterComponent,
        MyOrdersReceiptComponent,
        CartRegistryComponent,
        ProductViewComponent,
        ChangeRegistryModalComponent,
        ResalePolicyModalComponent,
        RegistryChangeComponent,
        ResaleRequestComponent,
        UserProfileComponent,
        RegisterPageComponent,
        ResaleTicketFormComponent,
        TicketFormComponent,
        ChangeUserRequestComponent,
        ChangeSupportRequestComponent,
        RefinementRequestComponent,
        ConversionRequestComponent,
        MyOrdersExtraProductsComponent,
        ExtraProductComponent,
        ShippingMethodComponent,
        ChangeShippingAddressModalComponent,
        PaymentMethodComponent,
        PaymentMethodModalComponent,
        PreemptionSeatsComponent, PrTagEventsComponent,
        PreemptionSeatsComponent,
        AddToGoogleComponent,
        SubscriptionTicketComponent,
        SubscriptionTicketItemComponent,
        OptionalPaymentMethodComponent,
        NewExtraProductComponent], providers: [
        BsModalRef,
        DatePipe,
        SwiperService,
        CurrencyPipe,
        EnumProductGuardService,
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaKey },
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    ] })
export class ShopModule { }
